import { log } from '../../services/utils';

import { controller } from '../../contexts/AdminContext';

import { noraApiRequest } from './';

export const getUserList = async () => {
	log( '* get user list' );
	const { data } = await noraApiRequest( {
		url: '/users',
		signal: controller.signal
	} );

	return data;
};

export const getUser = async id => {
	log( '* get user' );
	const { data } = await noraApiRequest( {
		url: `/users/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createUser = async data => {
	log( '* create user' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: '/users',
		params: { password: btoa( data.pass ) },
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateUser = async data => {
	log( '* update user' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/users',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteUser = async id => {
	log( '* delete user' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/users/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const updateUserPhoto = async ( id, photoId ) => {
	log( '* update user photo' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `/users/${ id }/photo/${ photoId }`,
		signal: controller.signal
	} );

	return response.data;
};
